














































import Station from "@/app/models/Station";
import BaseModal from "@/resources/components/BaseModal.vue";
import {Component, Vue, Watch} from "vue-property-decorator";
import ArrowRightSvg from "@/assets/svg/arrow-right.svg";
import FileSvg from "@/assets/svg/file.svg";
import PdfSvg from "@/assets/svg/pdf.svg";
import ImageSvg from "@/assets/svg/image.svg";

@Component({
    components: { BaseModal, ArrowRightSvg, FileSvg, PdfSvg, ImageSvg },
})
export default class StationShow extends Vue {
    get station(): Station|null {
        return this.$store.state.data.station;
    }
}
